module.exports = __webpack_public_path__ + "static/numbering-96d08806bb60095e4d0c70c74ca8d3b6.png";